import { shippingBacklog } from './shipping-backlog-en.i18n';

export const en = {
  shippingBacklog,
};
